import builtInValidators from './validators';

export default {
  /**
   * Process a single specification of validators into concrete array of actual validator
   * functions to call along with the information to call them with. This provides a array
   * of validator functions to be run on a single attribute.
   *
   * @param {Object} validatorSpec - Hash/array specifying the validators to run.
   * @return {Array} - Validator functions to call and info to provide them during execution.
   */
  getValidatorListFromSpec(validatorSpec) {
    const validatorSpecs = Array.isArray(validatorSpec) ? validatorSpec : [validatorSpec];
    const validators = [];

    validatorSpecs.forEach((validator) => {
      if (typeof validator === 'function') {
        validator = { // eslint-disable-line no-param-reassign
          fn: validator
        };
      }

      // all validators specified for a property are boiled down into array of functions
      Object.keys(validator).filter(key => key !== 'name' && key !== 'msg').forEach(validatorName => {
        const validateObj = {
          fn: validatorName === 'fn' ? validator.fn : builtInValidators.functions[validatorName],
          param: validatorName === 'fn' ? undefined : validator[validatorName],
          msg: validator.msg || builtInValidators.messages[validatorName],
          name: validator.name
        };

        validators.push(validateObj);
      });
    }, this);

    return validators;
  },

  /**
   * Converts a hash of validator specs to the runnable validators
   * Each key represents an attribute of the data and each value represents a list of all
   *  validator functions to run on that attribute.
   * @param {Object} validatorHash - The base validator hash
   * @param {string} [key] - Limits returned validators to the provided attribute
   */
  getValidators(validatorHash, key) {
    const validators = {};

    if (validatorHash) {
      Object.keys(validatorHash).forEach(currentAttr => {
        const validatorSpec = validatorHash[currentAttr];

        if (typeof key === 'undefined' || key === currentAttr) {
          if (validatorSpec) {
            validators[currentAttr] = this.getValidatorListFromSpec(validatorSpec);
          }
        }
      }, this);
    }

    return validators;
  }
};
